// Youtube Iframe API
export const VIDEO_PLAY = 'YOUTUBE_VIDEO_PLAYS';
export const VIDEO_STOP = 'YOUTUBE_VIDEO_STOP';
export const VIDEO_FINISH = 'YOUTUBE_VIDEO_FINISH';

export const PLATFORM_VIDEO_PLAY = 'PLATFROM_VIDEO_PLAY';


// Modals
export const PROMOBOX = 'js-promobox-ma';
export const PROMOBOX_BUTTON = 'js-promobox-ma-button';
export const PROMOBOX_WRAPPER = 'js-promobox-ma-wrapper';
export const IS_OPEN = 'is-open';
export const TOGGLE_PROMOBOX_EVENT = 'toggle-promobox-modal';
